import Const from 'constants';

const defaultState = {
    on: false,
    isOn() {
        return Boolean(this.on);
    },
};

export default function (state = defaultState, action) {
    if (action.type === Const.PLAYER_GROUPINGS_SWITCH_IS_ON) {
        state = {...state};
        state.on = Boolean(action.isOn);
    } else if (inArray(action.type, [Const.RESET_ALL_SETTINGS, Const.FILTER_BY_SLATE])) {
        state = {
            ...defaultState,
            on: false,
        };
    }

    return state;
}
